import { IconSvg, IconSvgProps } from "./icon"

export default function Pencil(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="m9.429 18.737-5.786 1.62 1.62-5.786L15.857 4.03a1.285 1.285 0 0 1 1.839 0l2.275 2.288a1.285 1.285 0 0 1 0 1.826L9.43 18.737Z" />
    </IconSvg>
  )
}
